import { Component, Input } from '@angular/core';
import { Reward } from '@app/shared/models/wallet.model';
import { ThemingAssets, ThemingGroups } from '@app/shared/services/theming.service';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'slotcom-reward-box',
  templateUrl: './reward-box.component.html',
  styleUrls: ['./reward-box.component.scss'],
  standalone: true,
  imports: [SharedModule],
})
export class RewardBoxComponent {
  @Input() reward: Reward;
  @Input() boxThemingGroup: ThemingGroups;
  @Input() iconThemingGroup: ThemingGroups;
  @Input() boxAsset: string;
  @Input() iconAsset: string;
  @Input() themingOverride: ThemingAssets;
  @Input() numberValue: number;
}
